import axios from 'axios'
import HTTP from './http'

export default {
    getList: () => axios.get(HTTP.PARAM_GROUP_LIST),
    addParamGroup: payload => axios.post(HTTP.PARAM_GROUP, payload),
    updateParamGroup: payload => axios.put(HTTP.PARAM_GROUP, payload),
    deleteParamGroup: payload => axios.delete(HTTP.PARAM_GROUP, { params: { id: payload } })
}
